// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pyroar: PokeData = {
  "id": 668,
  "name": "pyroar",
  "height": 15,
  "weight": 815,
  "base_experience": 177,
  "types": [
    PokeType.FIRE,
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "leer",
    "ember",
    "flamethrower",
    "hyper-beam",
    "crunch",
    "endeavor",
    "hyper-voice",
    "overheat",
    "fire-fang",
    "echoed-voice",
    "incinerate",
    "work-up",
    "noble-roar"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "leer",
    "ember",
    "flamethrower",
    "crunch",
    "hyper-voice",
    "fire-fang",
    "purification",
    "blaze-kick",
    "scary-face",
    "fire-ball",
    "sunny-day"
  ],
  "evolution_chain": {
    "id": 343,
    "item": null,
    "species": [
      {
        "name": "litleo",
        "order": 668,
        "types": [
          PokeType.FIRE,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pyroar",
        "order": 669,
        "types": [
          PokeType.FIRE,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 667,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 145,
    "ability_power": 149
  },
  "stat_changes": [],
  "catch_rate": 65,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
